<button
  [ngClass]="{
    'disabled': isDisabled,
    }"
  (click)="handleClick()"
>
  <div class="text">
    <ng-content></ng-content>
  </div>
</button>
